import { deleteAccessorySuccess, postAccessorySuccess } from "src/store/actions/accessories";
import { deleteConditionalRebatesSuccess, putConditionalRebatesSuccess } from "src/store/actions/conditionalRebates";
import { patchPaymentsSuccess } from "src/store/actions/payments";
import { personAuthSuccess } from "src/store/actions/personAuth";
import { pollingSuccess } from "src/store/actions/poller";
import { deleteTradeInSuccess, patchTradeInSuccess } from "src/store/actions/tradeIn";
import { postVehicleSuccess } from "src/store/actions/vehicles";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { DealState, GarageRequestAccess } from "Types/state";
import { authenticationMergeRequest, authenticationMergeSuccess, getDealSuccess, updateUUID } from "../actions/deal";
import { CreateDealResponseAction } from "../dataService/actions/deal";
import { DealResponses } from "../dataService/types";

const initialState = {
    accessRequest: undefined,
    current_data_revision: undefined,
    person: undefined,
    uuid: undefined,
};

type HandledActions =
    | CreateDealResponseAction
    | ReturnType<typeof getDealSuccess>
    | ReturnType<typeof updateUUID>
    | ReturnType<typeof pollingSuccess>
    | ReturnType<typeof patchTradeInSuccess>
    | ReturnType<typeof deleteTradeInSuccess>
    | ActionType<typeof putConditionalRebatesSuccess>
    | ActionType<typeof deleteConditionalRebatesSuccess>
    | ActionType<typeof patchPaymentsSuccess>
    | ActionType<typeof postAccessorySuccess>
    | ActionType<typeof deleteAccessorySuccess>
    | ActionType<typeof postVehicleSuccess>
    | ActionType<typeof authenticationMergeRequest>
    | ActionType<typeof authenticationMergeSuccess>
    | ActionType<typeof personAuthSuccess>;

function deal(state: DealState = initialState, action: HandledActions): DealState {
    switch (action.type) {
        case DealResponses.CreateSuccess:
            return { ...state, ...action.data };
        case getDealSuccess.type:
            return {
                ...state,
                current_data_revision: action.payload.deal.current_data_revision,
                person: action.payload.deal.person,
                experiments: action.payload.deal.experiments,
            };
        case pollingSuccess.type:
            return {
                ...state,
                current_data_revision: action.payload.deal.current_data_revision,
                experiments: action.payload.deal.experiments,
            };
        case DealResponses.GetDealPersonSuccess:
        case DealResponses.PatchDealPersonSuccess:
            return { ...state, ...action.data };
        case updateUUID.type:
            const { uuid } = action.payload;
            return {
                ...state,
                uuid,
            };
        case DealResponses.UpdateAccessRequest:
            const newAccessRequest = {
                ...action.data.accessRequest,
            } as GarageRequestAccess;
            return {
                ...state,
                accessRequest: newAccessRequest,
            };
        case putConditionalRebatesSuccess.type:
        case deleteConditionalRebatesSuccess.type:
        case patchTradeInSuccess.type:
        case deleteTradeInSuccess.type:
        case patchPaymentsSuccess.type:
        case postAccessorySuccess.type:
        case deleteAccessorySuccess.type:
        case postVehicleSuccess.type:
        case DealResponses.IncrementRevision:
            return {
                ...state,
                current_data_revision: state.current_data_revision && state.current_data_revision + 0.1,
            };

        case DealResponses.GetDealError:
            return {
                ...initialState,
            };

        case authenticationMergeRequest.type:
            return {
                ...state,
                accessRequest: undefined,
                uuid: action.payload.dealData.verifiedUuid,
            };

        case authenticationMergeSuccess.type:
            return {
                ...state,
                current_data_revision: action.payload.deal.current_data_revision,
                experiments: action.payload.deal.experiments,
                person: action.payload.deal.person,
            };
        case personAuthSuccess.type:
            return {
                ...state,
                person: action.payload.person,
            };

        default:
            return state;
    }
}

export default deal;
